import { useState } from "react";

const ago = (ts) => {
  const m = Math.round((Date.now() - new Date(ts)) / 60000);
  return m < 60 ? `${m}m` : m < 1440 ? `${Math.round(m / 60)}h` : `${Math.round(m / 1440)}d`;
};

const Item = ({ h }) => (
  <li className="py-3 border-b border-[color:var(--line)] last:border-none" data-testid={`desk-hl-${h.key}`}>
    <div className="flex items-center gap-2 flex-wrap mb-1">
      {h.tag ? <span className={`desk-tag ${h.tag.impact}`} data-testid={`desk-hl-tag-${h.key}`}>{h.tag.impact} · {h.tag.strength}</span> : <span className="desk-tag Volatile-unclear">tagging…</span>}
      <span className="text-sm text-[color:var(--mute)]">{h.source} · {ago(h.published)}</span>
    </div>
    <a href={h.link || undefined} target="_blank" rel="noreferrer noopener" className="text-lg font-semibold leading-snug hover:text-[color:var(--gold)]">{h.title}</a>
    {h.tag?.reason && <div className="text-base text-[color:var(--mute)] mt-1">{h.tag.reason}</div>}
  </li>
);

export const Headlines = ({ news, trump }) => {
  const [tab, setTab] = useState("news");
  const [all, setAll] = useState(false);
  const rows = tab === "news" ? news : trump;
  const top = [...rows].sort((a, b) => (b.tag?.strength || 0) - (a.tag?.strength || 0) || (b.published > a.published ? 1 : -1)).slice(0, 3);
  const shown = all ? rows : top;
  return (
    <section className="desk-card" data-testid="desk-headlines">
      <h2>{all ? "All headlines" : "Top headlines · strongest first"}</h2>
      <div className="desk-tabs">
        <button className={`desk-tab ${tab === "news" ? "on" : ""}`} onClick={() => setTab("news")} data-testid="desk-tab-news">News ({news.length})</button>
        <button className={`desk-tab ${tab === "trump" ? "on" : ""}`} onClick={() => setTab("trump")} data-testid="desk-tab-trump">Trump ({trump.length})</button>
      </div>
      {rows.length === 0 ? <p className="text-base text-[color:var(--mute)]" data-testid="desk-hl-empty">Nothing yet.</p> :
        <ul data-testid={`desk-hl-list-${tab}`}>{shown.map((h) => <Item key={h.key} h={h} />)}</ul>}
      {rows.length > 3 && <button className="desk-more" onClick={() => setAll(!all)} data-testid="desk-hl-toggle">{all ? "Show top 3" : `Show all ${rows.length}`}</button>}
    </section>
  );
};
